import React, { ReactNode, useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import {
  DATA_ROOM_NODE_LONG_TAGS,
  DATA_ROOM_NODE_SHORT_TAGS,
  DataRoomNode,
  DataRoomNodeTag,
} from 'router/subrouters/DataRoom/models/DataRoomNode';
import ArrowrightIcon from 'icons/Arrowright.icon';
import FloatingBanner from 'components/FloatingBanner';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';

import './TagDocumentBanner.styles.scss';

type TagDocumentBannerProps = {
  className?: string;
  node: DataRoomNode;
  tag: DataRoomNodeTag;
  anchor: ReactNode;
  updateDataRoomNode: (node: DataRoomNode) => void;
  onSuccessTag: (node: DataRoomNode) => void;
  onTagAnotherFile: () => void;
};

const TagDocumentBanner: React.FC<TagDocumentBannerProps> = (props) => {
  const {
    className,
    tag,
    node,
    anchor,
    onTagAnotherFile,
    updateDataRoomNode,
    onSuccessTag,
  } = props;

  const classes = classNames('tag-document-banner', className);
  const { _id: nodeId } = node;

  const { t } = useTranslation();

  const tagThisDocument = useCallback(async () => {
    try {
      const { data } = await dataRoomApi.nodes.tagDataRoomNode(nodeId, tag);
      onSuccessTag(data);
    } catch {
      return;
    }
  }, [nodeId, tag, onSuccessTag]);

  const hideTagBanner = useCallback(() => {
    updateDataRoomNode({ ...node, denyTagNudging: true });
    dataRoomApi.nodes.hideNodeTagBanner(nodeId);
  }, [node, nodeId, updateDataRoomNode]);

  return (
    <FloatingBanner
      showOnPhablet
      showBannerNotification={!!tag}
      anchor={anchor}
      onClose={hideTagBanner}
    >
      <div className={classes}>
        <p>{t('isThisTag', { tag: t(DATA_ROOM_NODE_LONG_TAGS[tag]) })}</p>
        <p>{t('taggingFilesTrackBuyers')}</p>

        <div className="actions">
          <Button
            className="confirm"
            onClick={(e) => {
              e.stopPropagation();
              tagThisDocument();
            }}
          >
            {t('yesTagFile', { tag: t(DATA_ROOM_NODE_SHORT_TAGS[tag]) })}
          </Button>
          <Button
            iconPosition="right"
            icon={ArrowrightIcon}
            onClick={(e) => {
              e.stopPropagation();
              onTagAnotherFile();
            }}
          >
            {t('useAnotherTag')}
          </Button>
        </div>
      </div>
    </FloatingBanner>
  );
};

export default TagDocumentBanner;
